import React from 'react';
import PropTypes from 'prop-types';
import getOrdinalSuffix from '../../../utils/ordinalSuffix';
import { DAY_NAMES, MONTH_NAMES } from '../../../utils/dateConstants';
import * as Styled from './styles';
import { useSportConfig } from '../../../hooks/useSportConfig';

const formatAllocationDateTime = dateString => {
    const date = new Date(dateString);

    const hourNum = date.getHours();
    const displayHour = hourNum > 12 ? hourNum - 12 : hourNum || 12;
    const timeFormatted = `${displayHour}${hourNum >= 12 ? 'pm' : 'am'}`;

    const dayOfWeek = DAY_NAMES[date.getDay()];
    const dayOfMonth = date.getDate();
    const monthName = MONTH_NAMES[date.getMonth()];

    return {
        time: timeFormatted,
        date: `${dayOfWeek} ${dayOfMonth}${getOrdinalSuffix(
            dayOfMonth
        )} ${monthName}`
    };
};

const SelectionNotAssigned = ({ eventName, allocationDate }) => {
    const { config } = useSportConfig();
    const { selectionNoun, selectionNounPlural } = config.labels;
    const { time, date } = formatAllocationDateTime(allocationDate);

    return (
        <Styled.Box>
            <Styled.BoxText>
                The {eventName} {selectionNounPlural} aren&apos;t quite ready
                yet. Check back here after{' '}
                <Styled.Highlighted>{time}</Styled.Highlighted> on{' '}
                <Styled.Highlighted>{date}</Styled.Highlighted> to find out your{' '}
                {selectionNoun}.
            </Styled.BoxText>
        </Styled.Box>
    );
};

SelectionNotAssigned.propTypes = {
    eventName: PropTypes.string.isRequired,
    allocationDate: PropTypes.string.isRequired
};

export default SelectionNotAssigned;
